"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = require("./dayjs");
var date_1 = require("./date");
var dates_1 = require("../constants/dates");
exports.canDiscountPassLoyaltyRestriction = function (discount, customer, externalCustomerLoyaltyTierId) {
    var discountLoyaltyTierId = discount.loyaltyTierId;
    if (!discountLoyaltyTierId) {
        return true;
    }
    var customerLoyaltyTierId = customer ? customer.loyaltyTierId : undefined;
    if (customerLoyaltyTierId) {
        return discountLoyaltyTierId === customerLoyaltyTierId;
    }
    if (externalCustomerLoyaltyTierId) {
        return discountLoyaltyTierId === externalCustomerLoyaltyTierId;
    }
    return false;
};
exports.canDiscountPassLoyaltyPointsRestriction = function (_a) {
    var discount = _a.discount, remainingLoyaltyPoints = _a.remainingLoyaltyPoints;
    var discountLoyaltyCost = discount.loyaltyCost;
    if (discountLoyaltyCost > 0 && discountLoyaltyCost > remainingLoyaltyPoints) {
        return false;
    }
    return true;
};
exports.canDiscountPassTimeRestriction = function (discount, timezone) {
    var applyDateRestriction = discount.applyDateRestriction, isRecurring = discount.isRecurring, startDate = discount.startDate, endDate = discount.endDate, startTime = discount.startTime, endTime = discount.endTime;
    if (applyDateRestriction) {
        if (isRecurring) {
            // check days of the week
            var day = dayjs_1.dayjs();
            var dayOfWeek = timezone ? day.tz(timezone).day() : day.day();
            var dayOfWeekInString = dates_1.mapDayOfWeek[dayOfWeek];
            if (!discount[dayOfWeekInString]) {
                return false;
            }
        }
        else {
            // check date range
            if (startDate && endDate && !date_1.isBetweenTwoDates(startDate, endDate, timezone)) {
                return false;
            }
        }
        // check time
        if (startTime && endTime && !date_1.isBetweenTwoTimes(startTime, endTime, timezone)) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=discounts.js.map